import styled from '@emotion/styled';
import { Skeleton } from '@mui/material';

const AvatarsContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 12px;

    @media (max-width: 1080px) {
        grid-template-columns: repeat(2, 1fr);
    }
`;

const AvatarSkeleton = styled(Skeleton)`
    aspect-ratio: 1;
    width: 100%;
    height: 100%;
    border-radius: 12px;
`;

interface Props {
    size?: number;
}

export const GenerateAvatarSkeleton = ({ size = 1 }: Props) => {
    return (
        <AvatarsContainer>
            {Array.from({ length: size }, (_, index) => (
                <AvatarSkeleton variant="rectangular" key={index} />
            ))}
        </AvatarsContainer>
    );
};
